import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { DriversState } from '../../types';

import { getDriverFuelAssignment } from '../operations/getDriverFuelAssignment';

import { STATUS_LOADING } from 'common/constants';

export const setDriverFuelAssignment = (builder: ActionReducerMapBuilder<DriversState>) => builder
  .addCase(getDriverFuelAssignment.pending, (state) => {
    state.fuelAssignment.loadingStatus = STATUS_LOADING.load;
  })
  .addCase(getDriverFuelAssignment.fulfilled, (state, { payload }) => {
    state.fuelAssignment.loadingStatus = STATUS_LOADING.done;
    state.fuelAssignment.data = payload;
  })
  .addCase(getDriverFuelAssignment.rejected, (state) => {
    state.fuelAssignment.loadingStatus = STATUS_LOADING.error;
  });